module.exports = __webpack_public_path__ + "img/電気回路_3_5_5.b311ff2e.png";